import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toUpper} from 'lodash';
import {hasAccessPermission} from '../../common/permissions/validations';
import {scopes, resources} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import {Container, Card, Grid, Button, Icon, Confirm, Modal, Table, Dropdown} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import CouriersTable from './couriersTable/couriersTable';
import {getCouriersColumns} from './couriersTable/couriersTableColumns';
import TransportistTable from './tranposrtistTable/transportistTable';
import {getTransportistColumns} from './tranposrtistTable/transportistTableColumns';
import {getDropdownOptions} from '../../common/util/dropdown';
import {downloadFile} from '../../common/util/file';

import './styles.scss';

const {
  navigateTo,
  fecthCouriersList,
  fecthTransportistList,
  updateTransportist,
  deleteTransportist,
  updateCourier,
  deleteCourier,
  fetchDealersAgencies,
  exportToExcelCouriers,
  exportToExcelTransportists,
  updateTransportistAgencies,
  cleanTransportistUrl,
} = Actions;

const NEW_COURIER_INITIAL_STATE = {
  'company': 'TE',
  'group': '01',
  'ruc': '',
  'name': '',
  'status': 'A',
  'phone': '',
  'address': '',
};

const LAST_TRANSPORT_INITIAL_STATE = {
  'inputId': null,
  'caretPos': 0,
};

const NEW_TRANSPORTIST_INITIAL_STATE = {
  'company': 'TE',
  'driverRuc': '',
  'driverName': '',
  'licencePlate': '',
  'courierRuc': '',
  'courierName': '',
  'courierAddress': '',
  'courierPhone': '',
};

const Index = () => {
  const permissions = useSelector((state) => state.session.permissions);
  // const loadingCouriers = useSelector((state) => state.couriers.loading);
  const couriersList = useSelector((state) => state.couriers.list);
  const transportistList = useSelector((state) => state.transportist.list);
  const dealersAgenciesList = useSelector((state) => state.dealersAgencies.list);
  const exportCouriersURL = useSelector((state) => state.exportCouriers.url);
  const exportTransportistURL = useSelector((state) => state.exportTransportists.url);
  const [courierSelected, setCourierSelected] = useState(null);
  const [transportistEditing, setTransportistEditing] = useState(null);
  const [courierEditing, setCourierEditing] = useState(null);
  const [lastTransportistInputChanged, setLastTransportistInputChanged] = useState(
    LAST_TRANSPORT_INITIAL_STATE,
  );
  const [lastCourierInputChanged, setLastCourierInputChanged] = useState(
    LAST_TRANSPORT_INITIAL_STATE,
  );
  const [addTransportist, setAddTransportist] = useState(null);
  const [addCourier, setAddCourier] = useState(null);
  const [showTransportistDeleteConfirmation, setShowTransportistDeleteConfirmation] = useState(false);
  const [showCourierDeleteConfirmation, setShowCourierDeleteConfirmation] = useState(false);
  const [transportistToDelete, setTransportistToDelete] = useState(null);
  const [courierToDelete, setCourierToDelete] = useState(null);
  const [showAgenciesModal, setShowAgenciesModal] = useState(false);
  const [agenciesModalTransportist, setAgenciesModalTransportist] = useState(null);
  const [dealerSelected, setDealerSelected] = useState(null);
  const [agencySelected, setAgencySelected] = useState(null);
  let inputRef = useRef();
  const transportistInputsRefs = [];
  const courierInputsRefs = [];
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.TransportistManagement, scopes.See) &&
     !hasAccessPermission(permissions, resources.TransportistManagement, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(cleanTransportistUrl());
    dispatch(fecthCouriersList());
    dispatch(fecthTransportistList());
  }, []);

  const setCourierRef = (input) => {
    inputRef = input;
    courierInputsRefs.push(inputRef);
  };
  
  const courierRowClickHandler = (e, selectedCourier) => {
    e.preventDefault();
    courierSelected && courierSelected.ruc === selectedCourier.ruc ?
      setCourierSelected(null) :
      setCourierSelected(selectedCourier);
  };

  useEffect(() => {
    courierSelected ?
      dispatch(fecthTransportistList({'ruc': courierSelected.ruc})) :
      dispatch(fecthTransportistList());
  }, [courierSelected]);

  const editTransportist = (e, transportist) => {
    e.preventDefault();
    setTransportistEditing(transportist);
  };

  const editCourier = (e, courier) => {
    e.preventDefault();
    setCourierEditing(courier);
  };
  
  const transportistSelected = (transportist) => {
    if (transportistEditing) {
      return transportistEditing.driverCode === transportist.driverCode ? true : false;
    }
    return false;
  };

  const courierSelectedToEdit = (courier) => {
    if (courierEditing) {
      return courierEditing.courierCode === courier.courierCode ? true : false;
    }
    return false;
  };

  const handleTransportistValue = (e, input) => {
    e.preventDefault();
    setTransportistEditing({...transportistEditing, [input.id]: toUpper(input.value)});
    setLastTransportistInputChanged({'inputId': input.id, 'caretPos': e.target.selectionStart});
  };

  const handleCourierValue = (e, input) => {
    e.preventDefault();
    const data = {...courierEditing, [input.id]: toUpper(input.value)};
    setCourierEditing(data);
    setLastCourierInputChanged({'inputId': input.id, 'caretPos': e.target.selectionStart});
  };

  const getTransportistEditingValue = (propId) => {
    return transportistEditing[propId];
  };

  const getCourierEditingValue = (propId) => {
    return courierEditing[propId];
  };

  const setTransportistRef = (input) => {
    inputRef = input;
    transportistInputsRefs.push(inputRef);
  };

  useEffect(() => {
    const input = transportistInputsRefs.find((x) => x.props.id === lastTransportistInputChanged.inputId);
    if (input) {
      input.focus();
      input.inputRef.current
        .setSelectionRange(lastTransportistInputChanged.caretPos, lastTransportistInputChanged.caretPos);
    }
  }, [transportistEditing]);

  useEffect(() => {
    const input = courierInputsRefs.find((x) => x.props.id === lastCourierInputChanged.inputId);
    if (input) {
      input.focus();
      input.inputRef.current
        .setSelectionRange(lastCourierInputChanged.caretPos, lastCourierInputChanged.caretPos);
    }
  }, [courierEditing]);

  const handleTransportistUpdate = () => {
    const params = courierSelected ? {'ruc': courierSelected.ruc} : null;
    dispatch(updateTransportist({'data': transportistEditing}, params));
  };

  const handleCourierUpdate = () => {
    const params = courierSelected ? {'ruc': courierSelected.ruc} : null;
    dispatch(updateCourier({'data': courierEditing}, params));
  };

  const cancelTransportistUpdate = () => {
    setTransportistEditing(null);
    setLastTransportistInputChanged(LAST_TRANSPORT_INITIAL_STATE);
  };

  const cancelCourierUpdate = () => {
    setCourierEditing(null);
    setLastCourierInputChanged(LAST_TRANSPORT_INITIAL_STATE);
  };

  const addTransportistButtonHandler = (e) => {
    e.preventDefault();
    setAddTransportist({...NEW_TRANSPORTIST_INITIAL_STATE,
      'courierRuc': courierSelected.ruc,
      'courierName': courierSelected.name,
      'courierAddress': courierSelected.address,
      'courierPhone': courierSelected.phone,
    });
  };

  const addCourierButtonHandler = (e) => {
    e.preventDefault();
    setAddCourier({...NEW_COURIER_INITIAL_STATE});
  };

  const changeNewTransportistValue = (e, column, value) => {
    e.preventDefault();
    setAddTransportist({...addTransportist, [column.id]: toUpper(value)});
  };

  const changeNewCourierValue = (e, column, value) => {
    e.preventDefault();
    setAddCourier({...addCourier, [column.id]: toUpper(value)});
  };

  const cancelAddTransportist = () => {
    setAddTransportist(null);
  };

  const cancelAddCourier = () => {
    setAddCourier(null);
  };

  const validateTransportist = (type) => {
    if (type === 'add') {
      return addTransportist ?
        addTransportist.courierRuc && addTransportist.driverRuc && addTransportist.driverName &&
          addTransportist.licencePlate && addTransportist.courierPhone ?
          false : true : false;
    }
    return transportistEditing ?
      transportistEditing.courierRuc && transportistEditing.driverRuc && transportistEditing.driverName &&
      transportistEditing.licencePlate && transportistEditing.courierPhone ?
        false : true : false;
  };

  const validateCourier = (type) => {
    if (type === 'add') {
      return addCourier ?
        addCourier.name && addCourier.ruc && addCourier.address && addCourier.phone ? false : true : false;
    }
    return courierEditing ?
      courierEditing.name && courierEditing.ruc &&
      courierEditing.address && courierEditing.phone ? false : true : false;
  };

  const saveNewTransportist = (e) => {
    e.preventDefault();
    const params = courierSelected ? {'ruc': courierSelected.ruc} : null;
    dispatch(updateTransportist({'data': addTransportist}, params));
  };

  const saveNewCourier = (e) => {
    e.preventDefault();
    const params = courierSelected ? {'ruc': courierSelected.ruc} : null;
    dispatch(updateCourier({'data': addCourier}, params));
  };

  const handleDeleteTransportist = (e, showConfirmation, transportist) => {
    e.preventDefault();
    setTransportistToDelete(transportist);
    setShowTransportistDeleteConfirmation(showConfirmation);
  };

  const handleDeleteCourier = (e, showConfirmation, courier) => {
    e.preventDefault();
    setCourierToDelete(courier);
    setShowCourierDeleteConfirmation(showConfirmation);
  };

  const deleteTransportistHandler = () => {
    const params = courierSelected ? {'ruc': courierSelected.ruc} : null;
    dispatch(deleteTransportist(transportistToDelete.driverCode, params));
  };

  const deleteCourierHandler = () => {
    const params = courierSelected ? {'ruc': courierSelected.ruc} : null;
    dispatch(deleteCourier(courierToDelete.courierCode, params));
  };

  useEffect(() => {
    cancelTransportistUpdate();
    cancelAddTransportist();
    setTransportistToDelete(null);
    setShowTransportistDeleteConfirmation(false);
    setShowAgenciesModal(false);
  }, [transportistList]);
   
  useEffect(() => {
    cancelCourierUpdate();
    cancelAddCourier();
    setCourierToDelete(null);
    setShowCourierDeleteConfirmation(false);
  }, [couriersList]);
  
  const showAgenciesModalHandler = (e, showModal, transportist) => {
    e.preventDefault();
    if (showModal) {
      dispatch(fetchDealersAgencies());
      setAgenciesModalTransportist({
        'group': '01',
        'courierCode': couriersList.find((x) => x.ruc === transportist.courierRuc).courierCode,
        'driverCode': transportist.driverCode,
        'agencyArray': transportist.agenciesArray.map((x) => {
          return {
            'identification': x.identification,
            'dealerName': x.dealerName,
            'code': x.code,
            'name': x.name,
          };
        }),
      });
      setDealerSelected(null);
      setAgencySelected(null);
    }
    setShowAgenciesModal(showModal);
  };
  
  const getDealersOptions = () => {
    return dealersAgenciesList ? getDropdownOptions(dealersAgenciesList, 'identification', 'name') : [];
  };

  const dealerSelectionHandler = (e, input) => {
    e.preventDefault();
    setDealerSelected(input.value);
  };
  
  const getAgenciesOptions = () => {
    return dealersAgenciesList && dealerSelected ?
      getDropdownOptions(dealersAgenciesList
        .find((x) => x.identification === dealerSelected).agencyArray, 'code', 'name') :
      [];
  };

  const agencySelectionHandler = (e, input) => {
    e.preventDefault();
    setAgencySelected(input.value);
  };

  const addAgencyHandler = (e) => {
    e.preventDefault();
    if (agenciesModalTransportist && dealerSelected && agencySelected &&
      !agenciesModalTransportist.agencyArray.find((x) =>
        x.identification === dealerSelected && x.code === agencySelected)) {
      const data = {...agenciesModalTransportist,
        'agencyArray': [...agenciesModalTransportist.agencyArray, {
          'identification': dealerSelected,
          'dealerName': dealersAgenciesList.find((x) => x.identification === dealerSelected).name,
          'code': dealersAgenciesList.find((x) => x.identification === dealerSelected).agencyArray
            .find((x) => x.code === agencySelected).code,
          'name': dealersAgenciesList.find((x) => x.identification === dealerSelected).agencyArray
            .find((x) => x.code === agencySelected).name,
        }],
      };
      setAgenciesModalTransportist(data);
    }
  };

  const deleteAgencyHandler = (e, agency) => {
    e.preventDefault();
    const data = agenciesModalTransportist.agencyArray
      .filter((x) => x.identification !== agency.identification || x.code !== agency.code);
    setAgenciesModalTransportist({...agenciesModalTransportist, 'agencyArray': data});
  };

  const saveTransportistAgenciesHandler = (e) => {
    e.preventDefault();
    const params = courierSelected ? {'ruc': courierSelected.ruc} : null;
    dispatch(updateTransportistAgencies({'data': agenciesModalTransportist}, params));
  };

  const exportCouriersHandler = (e) => {
    e.preventDefault();
    dispatch(exportToExcelCouriers());
  };

  const exportTransportistHandler = (e) => {
    e.preventDefault();
    dispatch(exportToExcelTransportists());
  };

  useEffect(() => {
    if (exportCouriersURL) {
      downloadFile(exportCouriersURL);
      dispatch(cleanTransportistUrl());
    }
  }, [exportCouriersURL, dispatch]);

  useEffect(() => {
    if (exportTransportistURL) {
      downloadFile(exportTransportistURL);
      dispatch(cleanTransportistUrl());
    }
  }, [exportTransportistURL, dispatch]);

  const couriersColumns = getCouriersColumns();
  const transportistColumns = getTransportistColumns();

  return (
    <Container fluid>
      <Card raised fluid style={{'backgroundColor': 'transparent'}}>
        <div className='title-bar'>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <div className='title'>
                  <h2>Gestión de Transportistas</h2>
                </div>
              </Grid.Column>
              <Grid.Column textAlign='right'>
                <Link to={paths.AgenciesManagement}>
                  <Button primary>Agencias</Button>
                </Link>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Card raised fluid>
              <Card.Header style={{'backgroundColor': 'red'}}>
                <Grid padded>
                  <Grid.Row columns={2} className='thin-header white'>
                    <Grid.Column className='flex middle'>
                      <h4>ADMINISTRACIÓN DE COURIERS</h4>
                    </Grid.Column>
                    <Grid.Column textAlign='right' className='flex middle end'>
                      {!addCourier ?
                        <Button secondary size='small' className='add-btns-pading'
                          onClick={(e) => addCourierButtonHandler(e)}>
                          <div className='flex middle'>
                            <Icon className='add-circle' color='green' size='big' />
                            <div>Agregar</div>
                          </div>
                        </Button> : ''
                      }
                      <Button secondary size='small' className='add-btns-pading' compact
                        onClick={(e) => exportCouriersHandler(e)}>
                        <img src={`${process.env.PUBLIC_URL}/icons/excel.svg`} alt='excel icon' width={25} />
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Header>
              <Card.Content>
                <CouriersTable
                  tableColumns={couriersColumns}
                  tableData={couriersList}
                  setCourierRef={setCourierRef.bind(this)}
                  editCourier={editCourier.bind(this)}
                  handleCourierValue={handleCourierValue.bind(this)}
                  getCourierEditingValue={getCourierEditingValue.bind(this)}
                  handleCourierUpdate={handleCourierUpdate.bind(this)}
                  cancelCourierUpdate={cancelCourierUpdate.bind(this)}
                  courierRowClickHandler={courierRowClickHandler}
                  courierSelectedToEdit={courierSelectedToEdit}
                  courierSelected={courierSelected}
                  validateCourier={validateCourier.bind(this)}
                  addCourier={addCourier}
                  handleDeleteCourier={handleDeleteCourier.bind(this)}
                  changeNewCourierValue={changeNewCourierValue.bind(this)}
                  saveNewCourier={saveNewCourier.bind(this)}
                  cancelAddCourier={cancelAddCourier.bind(this)} />
              </Card.Content>
            </Card>
            <Card raised fluid>
              <Card.Header style={{'backgroundColor': 'red'}}>
                <Grid padded>
                  <Grid.Row columns={2} className='thin-header white'>
                    <Grid.Column className='flex middle'>
                      <h4>ADMINISTRACIÓN DE TRANSPORTISTAS {courierSelected ? ` DE ${courierSelected.name}` : ''}</h4>
                    </Grid.Column>
                    <Grid.Column textAlign='right' className='flex middle end'>
                      {courierSelected && !addTransportist ?
                        <Button secondary size='small' className='add-btns-pading'
                          onClick={(e) => addTransportistButtonHandler(e)}>
                          <div className='flex middle'>
                            <Icon className='add-circle' color='green' size='big' />
                            <div>Agregar</div>
                          </div>
                        </Button> : ''
                      }
                      <Button secondary size='small' className='add-btns-pading' compact
                        onClick={(e) => exportTransportistHandler(e)}>
                        <img src={`${process.env.PUBLIC_URL}/icons/excel.svg`} alt='excel icon' width={25} />
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Header>
              <Card.Content>
                <TransportistTable
                  tableColumns={transportistColumns}
                  tableData={transportistList}
                  editTransportist={editTransportist}
                  transportistSelected={transportistSelected}
                  handleTransportistValue={handleTransportistValue}
                  setTransportistRef={setTransportistRef.bind(this)}
                  getTransportistEditingValue={getTransportistEditingValue}
                  handleTransportistUpdate={handleTransportistUpdate}
                  cancelTransportistUpdate={cancelTransportistUpdate}
                  addTransportist={addTransportist}
                  changeNewTransportistValue={changeNewTransportistValue}
                  cancelAddTransportist={cancelAddTransportist}
                  saveNewTransportist={saveNewTransportist}
                  handleDeleteTransportist={handleDeleteTransportist}
                  showAgenciesModalHandler={showAgenciesModalHandler.bind(this)}
                  validateTransportist={validateTransportist.bind(this)} />
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Confirm
        open={showTransportistDeleteConfirmation}
        header={`Transportista: ${transportistToDelete ? transportistToDelete.driverName : ''}`}
        content={<h3 style={{'padding': '1.25rem'}}>¿Está seguro que desea eliminar el transportista?</h3>}
        onCancel={(e) => handleDeleteTransportist(e, false, null)}
        onConfirm={(e) => deleteTransportistHandler(e)}
      />
      <Confirm
        open={showCourierDeleteConfirmation}
        header={`Courier: ${courierToDelete ? courierToDelete.name : ''}`}
        content={<Container style={{'padding': '1.25rem'}}>
          <strong>
            Esta acción eliminará permanentemente al courier y a todos sus transportistas asociados
          </strong>
          <h3>¿Está seguro que desea eliminar el courier?</h3>
        </Container>}
        onCancel={(e) => handleDeleteCourier(e, false, null)}
        onConfirm={(e) => deleteCourierHandler(e)}
      />
      <Modal open={showAgenciesModal}
        /* onOpen={(e) => openComboKatashikiesModal(e)}
        onClose={(e) => closeComboKatashikiesModal(e)} */
        closeOnEscape={true}
        closeOnDimmerClick={true}>
        <Modal.Header>
          <div className='header flex'>
            <h2 className='flex grow' style={{'margin': 0}}>Agencias asignadas</h2>
            <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
              onClick={(e) => showAgenciesModalHandler(e, false)} />
          </div>
        </Modal.Header>
        <Modal.Content>
          <div className='content'>
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={6}>
                  <h4 style={{'marginBottom': '0.25em'}}>Concesionario</h4>
                  <Dropdown search selection fluid options={getDealersOptions()} value={dealerSelected}
                    onChange={(e, input) => dealerSelectionHandler(e, input)} />
                </Grid.Column>
                <Grid.Column width={6}>
                  <h4 style={{'marginBottom': '0.25em'}}>Agencia</h4>
                  <Dropdown search selection fluid options={getAgenciesOptions()} value={agencySelected}
                    onChange={(e, input) => agencySelectionHandler(e, input)} />
                </Grid.Column>
                <Grid.Column>
                  <Icon className='add-circle' size='big' color='green' style={{'marginTop': 'calc(0.25em + 20px)'}}
                    link onClick={(e) => addAgencyHandler(e)} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Table compact striped textAlign='center'>
              <Table.Header fullWidth>
                <Table.HeaderCell>CONCESIONARIO</Table.HeaderCell>
                <Table.HeaderCell>AGENCIA</Table.HeaderCell>
                <Table.HeaderCell width={1}></Table.HeaderCell>
              </Table.Header>
              <Table.Body style={{'overflowY': 'overlay'}}>
                {agenciesModalTransportist && agenciesModalTransportist.agencyArray.map((agency, i) => {
                  return (
                    <Table.Row key={`agecies-header${i}`}>
                      <Table.Cell>{agency.dealerName}</Table.Cell>
                      <Table.Cell>{agency.name}</Table.Cell>
                      <Table.Cell width={1}>
                        <Icon name='trash' link size='big' color='red'
                          onClick={(e) => deleteAgencyHandler(e, agency)} />
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary size='small' compact onClick={(e) => saveTransportistAgenciesHandler(e)}>
            <div className='flex middle'>
              <Icon name='save' size='big' />
              <div>GUARDAR</div>
            </div>
          </Button>
        </Modal.Actions>
      </Modal>
    </Container>
  );
};
 
export default Index;
